'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditprogramresults = require('./auditprogramresults.html');

var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);

var _auditprogramresults3 = require('./auditprogramresults.controller');

var _auditprogramresults4 = _interopRequireDefault(_auditprogramresults3);

require('./auditprogramresults.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogramresultsComponent = {
  restrict: 'E',
  bindings: {},
  template: _auditprogramresults2.default,
  controller: _auditprogramresults4.default,
  controllerAs: 'vm'
};

exports.default = auditprogramresultsComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramresults/auditprogramresults.component.js